
import creditCardType from 'credit-card-type'
import { Component, Prop, Vue } from 'vue-property-decorator'
import EInput from './Input.vue'

@Component({
  components: {
    EInput,
  },
})
export default class CreditCardInput extends Vue {
  @Prop({ required: true }) readonly label!: any

  @Prop() readonly placeholder!: string

  @Prop() readonly value!: string

  @Prop() readonly rules!: Function[]

  private cardType: creditCardType.CreditCardTypeInfo | null = null

  get cardNumber(): string {
    return this.prettyCardNumber(this.value)
  }

  set cardNumber(val: string) {
    [this.cardType] = creditCardType(val)

    let number = val.replace(/\D/g, '')

    if (this.cardType && this.cardType.lengths) {
      number = number.substr(0, this.cardType.lengths[0])
    }

    this.$emit('input', number)
  }

  get cardFlag(): string | null {
    return (this.value && this.cardType && this.cardType.type) || null
  }

  prettyCardNumber(cardNumber: string): string {
    const card = this.cardType

    if (cardNumber && card && card.gaps) {
      const offsets = [0].concat(card.gaps, cardNumber.length)
      const components = []

      for (let i = 0; offsets[i] < cardNumber.length; i += 1) {
        const start = offsets[i]
        const end = Math.min(offsets[i + 1], cardNumber.length)
        components.push(cardNumber.substring(start, end))
      }

      return components.join(' ')
    }

    return cardNumber
  }
}
